// extracted by mini-css-extract-plugin
export default {"business":"business__aYa7h","businessLink":"businessLink__WOjzF"};